const resultFunction =
  (inProgressOrders) =>
  (assetNames, { isRestoring = false } = {}) => {
    const countOrders = (asset) => [...inProgressOrders].filter((order) => order.toAsset === asset)
    const result = {}

    for (const asset of assetNames) {
      result[asset] = isRestoring ? 0 : countOrders(asset).length
    }

    return result
  }

const createInProgressPurchasesCountMapSelectorDefinition = {
  id: 'createInProgressPurchasesCountMap',
  resultFunction,
  dependencies: [{ selector: 'inProgressOrders' }],
}

export default createInProgressPurchasesCountMapSelectorDefinition
